//#region Asset Imports

import 'devextreme/ui/form'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popup'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/tabs'
import 'devextreme/ui/toolbar'

//#endregion

import { LoggerService } from '../../common/common.module'
import { PaymentsController } from './payments.controller'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

//#region Asset Imports

import './payments.scss'
import * as TEMPLATE from './payments.tpl.html'

//#endregion

export class PaymentsDirective implements ng.IDirective {

    restrict = 'E'
    scope = {
        source: '='
    }
    template = TEMPLATE

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'logger', USER_SESSION_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        userSession: UserSessionService
    ) => new PaymentsController(
        $scope,
        $q,
        $timeout,
        userSession
    )]

    transclude = true
}